import { shuffleArray } from "./utils";
export enum Difficulty {
    EASY = 'easy',
    HARD = 'hard',
    MEDIUM = 'medium'
}
export type Question = {
    category: string;
    correct_answer: string;
    difficulty: string;
    incorrect_answers: string[];
    question: string;
    type: string;
}
export type QuestionState = Question & {answers: string[]}

export const fetchQuizQuestions = async(amount:number, difficulty: Difficulty) => {
    const endpoint = `https://opentdb.com/api.php?amount=${amount}&category=18&difficulty=${difficulty}&type=multiple`;
    const res = await fetch(endpoint);
    const data = await res.json();  
    return data.results.map((question: Question) => ({
        ...question,
        answers: shuffleArray([...question.incorrect_answers, question.correct_answer])
    }))
}